export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.581 1.186a1 1 0 00-1.162 0l-7 5A1 1 0 001 8h2v5H1a1 1 0 100 2h14a1 1 0 100-2h-2V8h2a1 1 0 00.581-1.814l-7-5zM11 13V8H5v5h6zM8 3.229L11.88 6H4.12L8 3.229z\" fill=\"#343B42\"/>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};